import { createContext } from '@shared/utils/createContext';

type BrannanDesignContextValue = Readonly<{
  reapplyDesign: () => void;
}>;

const [BrannanDesignProvider, useBrannanDesignContext] = createContext<BrannanDesignContextValue>({
  name: 'BrannanDesignContext',
});

export { BrannanDesignProvider, useBrannanDesignContext };
